import React from 'react';
import { BrainIcon, CheckIcon, ClockIcon, CopyIcon, ListChecksIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { TestimonialMarquee } from '../components/TestimonialMarquee';
import { bonuses, faqs, features, formatPillars, heroIncludes, included, moduleTitles, offerChecklist, outcomes, painPoints, stats } from '../data/content';
const EBOOK_COVER_URL = 'https://cdn.magicpatterns.com/uploads/77kVvdUnL1pxrCtCw1HiqK/Mockup_ADHD.png';
const WHATS_INSIDE_DESKTOP_URL = 'https://cdn.magicpatterns.com/uploads/jsQsLUehzzCRc3yJ3M4psa/whats-inside-web.webp';
const WHATS_INSIDE_MOBILE_URL = 'https://cdn.magicpatterns.com/uploads/tbPg4xcWZVrs4YTv9uKywj/whats-inside-mobile.webp';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/1roViPmDXjaiz1sGkRNVUW/Logo_IG.jpg';
const phases = [{
  label: 'Dump',
  description: 'Get every task and idea out of your head and onto the page.'
}, {
  label: 'Execute',
  description: 'Micro-steps that break paralysis in the first 48 hours.'
}, {
  label: 'Feed',
  description: 'Meals and groceries decided before hunger hits.'
}, {
  label: 'Control',
  description: 'A 3-question filter between you and the impulse buy.'
}, {
  label: 'Recover',
  description: 'Spot the crash early and reset in 72 hours.'
}, {
  label: 'Reset',
  description: '5-minute sprints that keep your home from piling up.'
}];
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-cream font-body text-slate-800" data-id="element-24" data-mp="3oj7yn8advkgp">

      {/* Top banner */}
      <header data-id="element-25" data-mp="3jitsjvsceklb">
        <div className="bg-brand-medium px-4 py-2 text-center text-xs font-bold tracking-wide text-white sm:text-sm" data-id="element-26" data-mp="3jmhn8y9ixd1m">
          <span aria-hidden="true" data-id="element-27" data-mp="2859ha8j8bovc">🧠 </span>Digital download — Instant access after purchase
        </div>
        
      </header>

      <main id="top" data-id="element-28" data-mp="243eh57d1bhj5">

        {/* Hero */}
        <section className="bg-brand-deep px-5 py-8 text-center text-white sm:py-14 lg:py-16" data-id="element-29" data-mp="245qxxh723lum">
          <div className="mx-auto max-w-4xl" data-id="element-30" data-mp="25ll5ala8vqgw">
            <h1 className="font-display text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-7xl" data-id="element-31" data-mp="2akfz0i9r2zfs">
              Stop the Mental Chaos.{' '}
              <span className="text-brand-gold" data-id="element-32" data-mp="1voq9491g225s">Start Executing Today.</span>
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-white/85 sm:mt-4 sm:text-xl" data-id="element-33" data-mp="20jvxrfm8duxk">
              <strong className="font-black text-white" data-id="element-34" data-mp="1mshb8yt47blr">The ADHD Brain-Dump &amp; Reset System™.</strong> Your brain dumps everything. Your system does the rest.
            </p>
            <img src={EBOOK_COVER_URL} alt="The ADHD Brain-Dump & Reset System — six modules plus 5 bonuses included" className="mx-auto mt-3 w-full max-w-[280px] bg-transparent object-contain sm:mt-5 sm:max-w-md lg:max-w-lg" data-id="element-35" data-mp="1cxpf7zf6kwt3" />
            <div className="mt-5 sm:mt-6" data-id="element-36" data-mp="13xtzrielefn9">
              <CtaButton label="Get Access Now — 19 USD" target="checkout" data-id="element-37" data-mp="17w00a8ou7yzq" />
            </div>
            <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-38" data-mp="p7zcc4ng76mq">
              🔒 One-time payment · Secure checkout in your local currency
            </p>

            {/* What you get */}
            <div className="mx-auto mt-8 max-w-2xl text-left sm:mt-10" data-id="element-39" data-mp="yaiawck7ax36">
              <p className="text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-40" data-mp="tam4k6o16tkg">
                Here is everything you get
              </p>
              <ul className="mt-4 grid gap-2 sm:grid-cols-2" role="list" data-id="element-41" data-mp="185imxcpk0xb9">
                {heroIncludes.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-42" data-mp="136fqggnn3zew">
                    <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-gold" aria-hidden="true" data-id="element-43" data-mp="1cylifqdw6gu3" />
                    <span className="text-[15px] leading-snug text-white/90" data-id="element-44" data-mp="1qxuwajemkyuw">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-7 text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-45" data-mp="1m02yj8rauiis">
                The 6 modules inside
              </p>
              <ul className="mt-4 space-y-2" role="list" data-id="element-46" data-mp="2a2hogvc2h9wa">
                {moduleTitles.map(module => <li key={module} className="flex items-start gap-3 border-l-2 border-brand-gold/60 pl-4 text-[15px] leading-snug text-white/90" data-id="element-47" data-mp="2etg4dtt585z0">
                    {module}
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* Format promise bar */}
        <section aria-label="Format promise" className="bg-[#E3EDF6] px-5 py-4 text-center text-sm font-bold sm:text-base text-brand-deep" data-id="element-48" data-mp="1r3vm7d4tdcqs">
          <span aria-hidden="true" data-id="element-49" data-mp="1w1x1dmz4crwz">⚡ </span>No motivation required. No guilt trips. Just results — plug-and-play modules you can use today
        </section>

        {/* What's inside — visual overview */}
        <section aria-labelledby="whats-inside-heading" className="bg-brand-cream px-5 py-12 sm:py-14" data-id="element-50" data-mp="37hbycqrbvjs3">
          <div className="mx-auto max-w-6xl" data-id="element-51" data-mp="3cfx3n4lfstne">
            <div className="mx-auto max-w-2xl text-center" data-id="element-52" data-mp="10tv3ujg8fpnv">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-53" data-mp="10tbjyx70ur77">
                Practical tools. Real solutions.
              </p>
              <h2 id="whats-inside-heading" className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-54" data-mp="r39ymd61zmvz">
                What&apos;s Inside
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-55" data-mp="i3wn7eydco8m">
                A complete system to help you get out of overwhelm and into real progress.
              </p>
            </div>
            <picture data-id="element-56" data-mp="84nxwzeg7xsl">
              <source media="(min-width: 900px)" srcSet={WHATS_INSIDE_DESKTOP_URL} type="image/webp" data-id="element-57" data-mp="868ueukbpqt3" />
              <img src={WHATS_INSIDE_MOBILE_URL} width={1440} height={960} loading="lazy" decoding="async" alt="Overview of the system: brain dump page, daily task matrix, energy audit, priority sequence, task paralysis guide, budget and impulse spending, cleaning and home organization, burnout recovery, project breakdown, and done-for-you worksheets" className="mx-auto mt-8 h-auto w-full max-w-5xl rounded-2xl object-contain shadow-sm" data-id="element-58" data-mp="37ea1o6pju6v" />
            </picture>
          </div>
        </section>

        {/* Pain points */}
        <section id="pain-points" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-59" data-mp="3i3zh9n0z4ada">
          <div className="mx-auto max-w-5xl" data-id="element-60" data-mp="3n1smodugd0ci">
            <div className="mx-auto max-w-2xl text-center" data-id="element-61" data-mp="elfwt6oje8t1">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-62" data-mp="em8xbpwwk22q">
                You are not alone
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-63" data-mp="5l18rzk6uflu">
                Does this sound like you?
              </h2>
            </div>
            <ul className="mt-8 grid gap-4 sm:grid-cols-2 sm:gap-5" role="list" data-id="element-64" data-mp="2qb08jlr2xidd">
              {painPoints.map(point => <li key={point.title} className="flex items-start gap-4 rounded-2xl border border-brand-medium/15 bg-white p-5 shadow-sm" data-id="element-65" data-mp="2ucc0vz1c8hp9">
                  <span className="mt-0.5 text-2xl" aria-hidden="true" data-id="element-66" data-mp="2mrro473atd9m">{point.emoji}</span>
                  <span data-id="element-67" data-mp="2ht6jlvh0k7fd">
                    <span className="block font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-68" data-mp="2htq4nl1ynbxm">
                      {point.title}
                    </span>
                    <span className="mt-1 block text-base leading-relaxed text-slate-700" data-id="element-69" data-mp="2rt77luptvbpw">
                      {point.text}
                    </span>
                  </span>
                </li>)}
            </ul>
            <blockquote className="mx-auto mt-10 max-w-3xl border-l-4 border-brand-medium pl-5 font-display text-xl font-bold italic leading-relaxed text-brand-deep sm:text-2xl" data-id="element-70" data-mp="1z51lb3j4leny">
              "You do not have a discipline problem. You have a missing operating system for your brain."
            </blockquote>
            <p className="mx-auto mt-5 max-w-3xl text-center text-base leading-relaxed text-slate-600" data-id="element-71" data-mp="1la8yrl4tiy7v">
              Most days start with the same negotiation: what to do first, what to eat, what to clean, what you already forgot. That is not laziness — it is executive function spent on decisions a written system should have made for you.
            </p>
          </div>
        </section>

        {/* Solution */}
        <section id="solution" className="bg-brand-deep px-5 py-12 text-white sm:py-16" data-id="element-72" data-mp="14ty2vjdliu4m">
          <div className="mx-auto max-w-3xl text-center" data-id="element-73" data-mp="18urr6duyaay1">
            <BrainIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-74" data-mp="1dtbdwghdbqrg" />
            <p className="mt-5 text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-75" data-mp="1iquuhn1jgfmk">The solution</p>
            <h2 className="mt-3 font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-id="element-76" data-mp="1nje6wgohp4ps">
              Introducing The ADHD Brain-Dump &amp; Reset System™
            </h2>
            <div className="mt-5 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-77" data-mp="1wjsvbowr2zxi">
              <p data-id="element-78" data-mp="21humkx4by5k2">
                6 plug-and-play modules + 5 bonus systems designed to turn mental chaos into automatic execution.
              </p>
              <p data-id="element-79" data-mp="3m1pzid4bfaik">
                <strong className="font-bold text-white" data-id="element-80" data-mp="3ly2anr9tfca6">No motivation required. No guilt trips.</strong> Just results.
              </p>
            </div>
            <div className="mt-8 grid gap-3 text-left sm:grid-cols-2" data-id="element-81" data-mp="3d0i5i78u0vua">
              {phases.map(phase => <div key={phase.label} className="rounded-xl border border-white/15 bg-white/5 p-4" data-id="element-82" data-mp="3815ldu9ci2ve">
                  <p className="text-sm font-black uppercase tracking-wide text-brand-gold" data-id="element-83" data-mp="8k78qkul5peh">{phase.label}</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/80" data-id="element-84" data-mp="4kyfri7ddvjz">{phase.description}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* Format — not a book to read */}
        <section id="format" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-85" data-mp="3qyq8avsjurdd">
          <div className="mx-auto max-w-5xl" data-id="element-86" data-mp="saax55cup9xd">
            <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="sb2jrqogzxbi">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-88" data-mp="nhraliw6r4gf">
                Zero fluff, 100% actionable
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-89" data-mp="2wfev5csl9nfn">
                This is not a book you read. It is a system you install.
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-90" data-mp="36dkvvr2nsnix">
                No chapters, no theory, no homework. You open a page, do the one small step on it, and move on.
              </p>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-91" data-mp="3fesrg1dsja9b">
              {formatPillars.map((pillar, index) => {
              const Icon = [ClockIcon, CopyIcon, ListChecksIcon][index];
              return <article key={pillar.label} className="flex flex-col rounded-2xl border border-brand-medium/15 bg-white p-6 shadow-sm" data-id="element-92" data-mp="3p3kk6bqodyla" data-mpi={index}>
                    <Icon className="h-7 w-7 text-brand-medium" aria-hidden="true" data-id="element-93" data-mp="6yhbyi5ex6gn" />
                    <h3 className="mt-4 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-94" data-mp="20pjnn0uvibx">
                      {pillar.label}
                    </h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-95" data-mp="qk9cltcix5pq">
                      {pillar.description}
                    </p>
                  </article>;
            })}
            </div>
            <p className="mx-auto mt-8 max-w-2xl rounded-2xl bg-brand-deep px-6 py-4 text-center text-base font-black text-white sm:text-lg" data-id="element-96" data-mp="gks83f90cxvc">
              Brain dump today. Executing tasks within 48 hours.
            </p>
          </div>
        </section>

        {/* The modules */}
        <section id="inside" className="bg-[#E7EFF7] px-5 py-12 sm:py-16" data-id="element-97" data-mp="3p2543ih68gd4">
          <div className="mx-auto max-w-6xl" data-id="element-98" data-mp="3u0pvqticxrpy">
            <div className="mx-auto max-w-2xl text-center" data-id="element-99" data-mp="3u1hsi7noxvht">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-100" data-mp="3g170h1anaav2">
                Fill-in-the-blank worksheets, ready to use
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-101" data-mp="3l24ed1omgiqr">
                The 6 Modules of the System
              </h2>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-102" data-mp="1lrs002c04nvd">
              {features.map((feature, index) => <article key={feature.title} className="rounded-2xl border border-brand-medium/15 bg-white p-5 shadow-sm" data-id="element-103" data-mp="1grnkofmtxz6q" data-mpi={index}>
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-medium font-display text-lg font-bold text-white" data-id="element-104" data-mp="29ifbsyp1fxn7">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-105" data-mp="20go63tuhzqtc">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-xs font-black uppercase tracking-wide text-brand-medium" data-id="element-106" data-mp="p2kid5ei6ywq">
                    {feature.pain}
                  </p>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600" data-id="element-107" data-mp="k2fz57m7nq2t">
                    {feature.description}
                  </p>
                </article>)}
            </div>
          </div>
        </section>

        {/* What's included */}
        <section id="included" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-108" data-mp="34r99zrgdpntg">
          <div className="mx-auto max-w-4xl" data-id="element-109" data-mp="39ihjenhpl96m">
            <div className="mx-auto max-w-2xl text-center" data-id="element-110" data-mp="39jaqxqohs2pt">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-111" data-mp="3ehubbmnft6g2">
                Everything in the package
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-112" data-mp="3jeuareps7ay7">
                What&apos;s Included
              </h2>
            </div>
            <ul className="mt-8 space-y-3" role="list" data-id="element-113" data-mp="3sgtr04sz2b03">
              {included.map(item => <li key={item.title} className="flex items-start gap-4 border-b border-brand-medium/15 pb-4 last:border-b-0" data-id="element-114" data-mp="1u2sg25xspow4">
                  <CheckIcon className="mt-1 h-5 w-5 flex-none text-brand-olive" aria-hidden="true" data-id="element-115" data-mp="1y3ueikjw1wx1" />
                  <span data-id="element-116" data-mp="12rcjdar6jm0z">
                    <span className="block font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-117" data-mp="12v0ay4d2dyd2">
                      {item.title}
                    </span>
                    <span className="mt-1 block text-[15px] leading-relaxed text-slate-600" data-id="element-118" data-mp="1cqtpftacg1xh">
                      {item.description}
                    </span>
                  </span>
                </li>)}
            </ul>
          </div>
        </section>

        {/* Bonuses */}
        <section id="bonuses" className="bg-[#F0F5FA] px-5 py-12 sm:py-16" data-id="element-119" data-mp="f4mi4bmnnvhf">
          <div className="mx-auto max-w-5xl" data-id="element-120" data-mp="tszidkss00hq">
            <div className="mx-auto max-w-2xl text-center" data-id="element-121" data-mp="ttsgjxdo5ho9">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-122" data-mp="p1hfgr76zpu4">
                Included at no extra cost
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-123" data-mp="1a3qmv892cdw">
                🎁 5 Bonus Systems Included
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-124" data-mp="27yvy9syokqlw">
                The extra systems that keep the chaos from coming back.
              </p>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-125" data-mp="1z0sa0owb9fqe">
              {bonuses.map(bonus => <article key={bonus.title} className="rounded-r-2xl border-l-4 border-brand-medium bg-white px-5 py-5 shadow-sm sm:px-6" data-id="element-126" data-mp="230kn9ewnga23">
                  <div className="flex items-start gap-4" data-id="element-127" data-mp="2qrq1jpmxyuaa">
                    <span className="text-3xl" aria-hidden="true" data-id="element-128" data-mp="2vq9ontd9uc48">{bonus.emoji}</span>
                    <div data-id="element-129" data-mp="2hqiczza897te">
                      <span className="inline-block rounded-full bg-brand-gold px-3 py-1 text-xs font-black uppercase tracking-wide text-brand-deep" data-id="element-130" data-mp="2hp73diu3p5ud">
                        {bonus.tag}
                      </span>
                      <h3 className="mt-3 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-131" data-mp="169ieglxadwqx">
                        {bonus.title}
                      </h3>
                      <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-132" data-mp="3czlp3h9c9eoz">
                        {bonus.description}
                      </p>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        {/* Proof */}
        <section id="proof" className="bg-brand-deep px-5 py-12 text-white sm:py-16" data-id="element-133" data-mp="2z8qn8ox9bxuw">
          <div className="mx-auto max-w-5xl" data-id="element-134" data-mp="2u9drfeoergg6">
            <div className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="2ua5o6stqrk81">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-136" data-mp="2p9hxk89fd5ec">
                Real results. Real people.
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-id="element-137" data-mp="2kcrah0z7d9jf">
                What changes in the first month
              </h2>
            </div>
            <dl className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-138" data-mp="iis0cixtgy8b">
              {stats.map(stat => <div key={stat.value} className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center" data-id="element-139" data-mp="ei7zb4a4hagw">
                  <dt className="font-display text-5xl font-bold leading-none text-brand-gold" data-id="element-140" data-mp="1wf33eh1k0yyg">
                    {stat.value}
                  </dt>
                  <dd className="mt-3 text-[15px] leading-relaxed text-white/80" data-id="element-141" data-mp="264wb36ykstxf">
                    {stat.label}
                  </dd>
                </div>)}
            </dl>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" className="bg-[#F0F5FA] py-12 sm:py-16" data-id="element-142" data-mp="1diblaaxr0pvz">
          <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-143" data-mp="1iglkcwmlgamv">
            <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-144" data-mp="1mhf5ji8njbc2">
              What buyers say
            </p>
            <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-145" data-mp="1rh1jjtwb0vlx">
              Bought it. Used it. Finally moving.
            </h2>
          </div>
          <div className="mt-8" data-id="element-146" data-mp="32udrogz3k0dw">
            <TestimonialMarquee data-id="element-147" data-mp="32xi2hx72hudj" />
          </div>
        </section>

        {/* Author */}
        <section id="author" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-148" data-mp="2ej3c3ivvf70f">
          <div className="mx-auto flex max-w-4xl flex-col items-center gap-7 text-center md:flex-row md:text-left" data-id="element-149" data-mp="29l1tez2cx9ph">
            <img src={LOGO_URL} alt="Prof. Kyra logo" className="h-40 w-40 flex-none rounded-full border-8 border-white bg-black object-contain shadow-lg" data-id="element-150" data-mp="2ncq7h7w62893" />
            <div data-id="element-151" data-mp="2x8tf2t9sez3f">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-152" data-mp="2x8a0nmjcisu5">
                Created with care
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-153" data-mp="2scm7kw1qtfjd">
                Meet Prof. Kyra
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-slate-700" data-id="element-154" data-mp="329qwv4qvxr4e">
                Prof. Kyra creates practical, field-tested digital systems designed to solve real everyday problems. Every resource is built to give real tools — not just information.
              </p>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-155" data-mp="xq7ywyqoru7p">
                The ADHD Brain-Dump &amp; Reset System™ was created for brains that are full of ideas and out of bandwidth — so execution stops depending on how you feel that day.
              </p>
            </div>
          </div>
        </section>

        {/* Outcomes */}
        <section id="outcomes" className="bg-[#E7EFF7] px-5 py-12 sm:py-16" data-id="element-156" data-mp="sxn722rcbr6t">
          <div className="mx-auto max-w-4xl text-center" data-id="element-157" data-mp="e0xifij4958j">
            <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-158" data-mp="j23bxiklowj4">
              What you will achieve
            </p>
            <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-159" data-mp="53dge7dfj4wv">
              After the System
            </h2>
            <p className="mx-auto mt-5 max-w-3xl font-display text-xl font-bold italic leading-relaxed text-brand-deep" data-id="element-160" data-mp="1zfadafun52zb">
              "Consistency is not a personality trait. It is a system written down once."
            </p>
            <ul className="mt-8 grid gap-4 text-left sm:grid-cols-2" role="list" data-id="element-161" data-mp="37yb0nq37llhi">
              {outcomes.map(outcome => <li key={outcome} className="flex items-start gap-3 rounded-2xl border border-brand-medium/15 bg-white p-5 shadow-sm" data-id="element-162" data-mp="3crdxc73a9b1x">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-olive" aria-hidden="true" data-id="element-163" data-mp="2xz2cjdv0z132" />
                  <span className="text-base leading-relaxed text-slate-700" data-id="element-164" data-mp="3qpklgvifjwoe">{outcome}</span>
                </li>)}
            </ul>
          </div>
        </section>

        {/* Offer */}
        <section id="offer" className="bg-brand-deep px-5 py-12 sm:py-16" data-id="element-165" data-mp="3vmkpz1zmsrde">
          <div className="mx-auto max-w-xl rounded-3xl bg-white p-7 text-center shadow-2xl sm:p-8" data-id="element-166" data-mp="3hocmscc04tts">
            <SparklesIcon className="mx-auto h-9 w-9 text-brand-medium" aria-hidden="true" data-id="element-167" data-mp="3lowolt7islm9" />
            <h2 className="mt-4 font-display text-3xl font-bold text-brand-deep sm:text-4xl" data-id="element-168" data-mp="2685xc6lhskcm">
              Everything You Get Today
            </h2>
            <p className="mt-2 font-display text-2xl font-bold text-brand-deep sm:text-3xl" data-id="element-169" data-mp="22rjiwn4yemoz">
              The ADHD Brain-Dump &amp; Reset System™
            </p>
            <ul className="mt-7 space-y-3 text-left" role="list" data-id="element-170" data-mp="1xsgr44dzicyy">
              {offerChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-slate-700" data-id="element-171" data-mp="2cp7qwerklqp3">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-olive" aria-hidden="true" data-id="element-172" data-mp="27otgiq2hy4nw" />
                  <span data-id="element-173" data-mp="1jz7l8dp8w9l6">{item}</span>
                </li>)}
            </ul>
            <div className="mt-8 flex flex-col items-center border-t border-brand-medium/15 pt-7 text-center" data-id="element-174" data-mp="1f3s85nz2ahpt">
              <p className="mt-1 font-display text-5xl font-bold leading-none text-brand-deep" data-id="element-175" data-mp="1tsg0zmhiwdc2">
                $19
              </p>
              <p className="mt-2 text-sm font-bold text-slate-600" data-id="element-176" data-mp="11au3tc4n5fa4">
                One-time payment — Yours forever
              </p>
            </div>
            <p className="mt-6 text-sm font-black text-brand-medium" data-id="element-177" data-mp="wb7tbag76d50">
              ✓ 7-Day Money-Back Guarantee. Full refund, no questions asked.
            </p>
            <CtaButton label="Get the System Now — 19 USD" className="mt-3 w-full" target="checkout" data-id="element-178" data-mp="1q0yfhbka1bkj" />
            <p className="mt-3 text-xs font-bold tracking-wide text-slate-600" data-id="element-179" data-mp="1urx02ncasvtl">
              🔒 Secure checkout in your local currency
            </p>
            <p className="mt-2 text-xs font-bold tracking-wide text-slate-500" data-id="element-180" data-mp="1ztdymc7b8670">
              📩 Instant delivery <span aria-hidden="true" data-id="element-181" data-mp="1333ox40r68qv">|</span> 🛡️ 7-day guarantee
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-182" data-mp="1c15vdz399tlj">
          <div className="mx-auto max-w-3xl" data-id="element-183" data-mp="1c41s5k3dac8e">
            <div className="text-center" data-id="element-184" data-mp="1h1ti48kgbo9y">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-185" data-mp="1gypat2bowcf2">
                Clear answers
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-186" data-mp="2sf5td4ijj965">
                Frequently Asked Questions
              </h2>
            </div>
            <div className="mt-8 space-y-3" data-id="element-187" data-mp="bsz4i4yd424s">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-188" data-mp="bvlj2ojo7hwi" />)}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section id="final-cta" className="bg-brand-deep px-5 py-12 text-center text-white sm:py-16" data-id="element-189" data-mp="248ty4p9b5u6">
          <div className="mx-auto max-w-3xl" data-id="element-190" data-mp="3u81bv3s9ic3z">
            <ZapIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-191" data-mp="3u8t6aba4i3so" />
            <h2 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-id="element-192" data-mp="3p6u2j0ah14v7">
              Stop Fighting Your Brain. Start Using It.
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-193" data-mp="3far4o6mnjse2">
              The ADHD Brain-Dump &amp; Reset System™ is the operating system your mind needs. No more chaos. No more guilt. Just execution.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-194" data-mp="1djnnszm65hl2">
              $19 <span className="align-middle font-body text-sm font-black uppercase tracking-wide" data-id="element-195" data-mp="1lkbsx7y08xjt">One-time payment</span>
            </p>
            <p className="mx-auto mt-4 max-w-2xl text-sm font-bold leading-relaxed text-white/75" data-id="element-196" data-mp="1blmmqcfh11je">
              ✓ 7-Day Money-Back Guarantee. If the system doesn&apos;t help you regain clarity and control, you get a full refund. No questions asked.
            </p>
            <CtaButton label="Get the System Now — 19 USD" className="mt-4" target="checkout" data-id="element-197" data-mp="12rrdotb8aqyh" />
            <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-198" data-mp="17l3u4g5r7rg5">
              🔒 Secure checkout in your local currency
            </p>
          </div>
        </section>

      </main>

      <footer className="bg-[#25364A] px-5 py-10 text-center text-white/70" data-id="element-199" data-mp="xu96b7cv0jsl">
        <ShieldCheckIcon className="mx-auto h-6 w-6 text-brand-gold" aria-hidden="true" data-id="element-200" data-mp="jvhuxspdtc85" />
        <p className="mt-4 text-sm" data-id="element-201" data-mp="nuqlypt1ew00">© 2026 The ADHD Brain-Dump &amp; Reset System™. All Rights Reserved.</p>
        <nav aria-label="Footer navigation" className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm" data-id="element-202" data-mp="58aqm5uejci8">
          <a href="#privacy" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-203" data-mp="a993pcmjl8v">
            Privacy Policy
          </a>
          <a href="#terms" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-204" data-mp="97ryt717qnr3">
            Terms of Service
          </a>
          <a href="mailto:profkyra@gmail.com" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-205" data-mp="j56f96n4zcje">
            Contact
          </a>
        </nav>
        <p className="mx-auto mt-6 max-w-3xl text-xs leading-relaxed text-white/55" data-id="element-206" data-mp="16wllhai1adzx">
          This product is an educational and informational resource. It does not constitute medical, psychological, or financial advice.
        </p>
      </footer>

    </div>;
}